// removed by extract-text-webpack-plugin
module.exports = {"animationWrapper":"_2oKG6kHEsCv0Nz2HeYaW3D","captionWrapper":"p-8-g5ZJTaeTrSB0fdn59","caption":"_2Aow6KQeyIzbzDd08MTQiu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FeatureMediaWithCaption/FeatureMediaWithCaption.module.scss
// module id = 763
// module chunks = 0